import { Alert, AlertTitle, Box, Grid, Typography } from '@mui/material';
import React from 'react';
import {
    Create,
    FormDataConsumer,
    Labeled,
    RadioButtonGroupInput,
    SimpleForm,
    TextInput,
    Toolbar,
    maxLength,
    required,
    useNotify,
    useRedirect,
} from 'react-admin';
import { useLocation } from 'react-router-dom';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import { getChainId } from '../../lib';
import { SaveConfirmButton } from '../../components';
import MoneyIcon from '@mui/icons-material/AttachMoney';
import { track, EVENTS } from '../../lib/analytics';

const toolbarSx = {
    justifyContent: 'space-between'
};

const charCounterSx = {
    top: '35%',
    right: '1%',
    width: 'auto',
    height: '100%',
    fontSize: 12,
    opacity: .75,
    fontFamily: 'Helvetica',
    textAlign: 'end',
};

const CreateBulkSend: React.FC = ({ ...props }) => {
    const { state: params }: { state: any } = useLocation();
    const notify = useNotify();
    const redirect = useRedirect();

    const [counterCharSms, setCounterCharSms] = React.useState(0);

    const MAX_LENGTH_SMS = 160;

    const counterCharInput = (valueInput: string) => {
        setCounterCharSms(valueInput.length);
    }

    const CreateToolbar = (props) => {

        return (
            <Toolbar {...props} sx={toolbarSx}>
                <FormDataConsumer>
                    {({ formData, ...rest }) => (
                        <SaveConfirmButton
                            {...rest}
                            formData={formData}
                            contentMessage={
                                <Alert
                                    variant="outlined"
                                    severity="warning"
                                    iconMapping={{
                                        warning: <MoneyIcon />,
                                    }}
                                >
                                    O envio de SMS está sujeito a <strong>cobranças</strong>. O <strong>custo aumenta</strong> proporcionalmente ao <strong>número de clientes</strong> selecionados. Verifique a lista de destinatários e esteja ciente dos custos adicionais.
                                </Alert>
                            }
                        />)}
                </FormDataConsumer>
            </Toolbar>
        );
    }
    return (
        <Permission permission={PERMISSIONS.BULK_SEND}>
            <Create
                {...props}
                title="Cadastrar envio em massa"
                mutationOptions={{
                    onSuccess: (data: any, variables: any) => {
                        track(EVENTS.BULK_SEND_DISPATCHED, {
                            channel: variables?.data?.type ?? 'sms',
                            audience_size: variables?.data?.customerIds?.length ?? 0,
                            chain_id: getChainId() ?? 'unknown',
                        });
                        notify('ra.notification.created', { type: 'info', messageArgs: { smart_count: 1 } });
                        redirect('list', 'bulk-sends');
                    },
                }}
            >
                <SimpleForm
                    toolbar={<CreateToolbar />}
                    defaultValues={{
                        type: 'sms',
                        chainId: getChainId(),
                        customerIds: params?.customerIds || [],
                    }}
                >
                    <Grid container>
                        <Grid size={{ xs: 12, sm: 12, md: 8, lg: 6 }} sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                            <TextInput
                                source="message"
                                label="Mensagem"
                                validate={[required(), maxLength(MAX_LENGTH_SMS)]}
                                inputProps={{ autoComplete: 'off', maxlength: MAX_LENGTH_SMS }}
                                onChange={(e) => counterCharInput(e.target.value)}
                                helperText={false}
                                fullWidth
                            />
                            <Box component="span" sx={charCounterSx}>{counterCharSms}/{MAX_LENGTH_SMS}</Box>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid size={{ xs: 12, sm: 12, md: 8, lg: 6 }}>
                            <Labeled label="Clientes">
                                <Typography>{params?.customerIds?.length || 0} clientes selecionados</Typography>
                            </Labeled>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid size={{ xs: 12, sm: 12, md: 8, lg: 6 }}>
                            <RadioButtonGroupInput
                                source="type"
                                label="Tipo" choices={[
                                    { id: 'sms', name: 'SMS' },
                                    // { id: 'whatsapp', name: 'Whatsapp' },
                                ]}
                            />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid size={{ xs: 12, sm: 12, md: 8, lg: 6 }}>
                            <Alert variant="outlined" severity="info" sx={{ width: '100%' }}>
                                <AlertTitle>Atenção</AlertTitle>
                                Você está prestes a enviar mensagens em massa. Este envio será realizado instantaneamente e não poderá ser desfeito. Por favor, verifique as informações cuidadosamente antes de prosseguir.
                            </Alert>
                        </Grid>
                    </Grid>
                </SimpleForm>
            </Create>
        </Permission>
    );
}

export default CreateBulkSend
